import { fetchAndOpenPdf } from "../utils/openPdfBlob";
import customAxios from "./customAxios";

export function parseLeaveApplicationAttributes(attributes = {}) {
  const blockOutRemovedAt = attributes.block_out_removed_at || attributes.blockOutRemovedAt || null;
  const blockOutRemoved = Boolean(
    attributes.block_out_removed ?? attributes.blockOutRemoved ?? blockOutRemovedAt
  );

  return {
    leaveType: attributes.leave_type || attributes.leaveType,
    leaveTypeLabel: attributes.leave_type_label || attributes.leaveTypeLabel,
    startAt: attributes.start_at || attributes.startAt,
    endAt: attributes.end_at || attributes.endAt,
    periodStartLabel: attributes.period_start_label || attributes.periodStartLabel,
    periodEndLabel: attributes.period_end_label || attributes.periodEndLabel,
    workingDaysOff: attributes.working_days_off ?? attributes.workingDaysOff,
    daysOffLabel: attributes.days_off_label || attributes.daysOffLabel,
    status: attributes.status || "pending",
    declinedReason: attributes.declined_reason || attributes.declinedReason,
    submittedAt: attributes.submitted_at || attributes.submittedAt,
    blockOutRemovedAt,
    blockOutRemoved,
  };
}

export const removedFromProfileCellProps = removed => (
  removed ? { className: "text-muted", style: { textDecoration: "line-through" } } : {}
);

export const getLeaveApplications = (baseUrl, queryParams = {}) => {
  const path = `${baseUrl}/leave_applications`;
  return customAxios.get(path, { params: queryParams })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const createLeaveApplication = (baseUrl, payload) => {
  const path = `${baseUrl}/leave_applications`;
  return customAxios.post(path, payload)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const updateLeaveApplication = (baseUrl, id, payload) => {
  const path = `${baseUrl}/leave_applications/${id}`;
  return customAxios.put(path, payload)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const getLeaveApplicationsDashboard = (baseUrl, queryParams = {}) => {
  const path = `${baseUrl}/leave_applications/dashboard`;
  return customAxios.get(path, { params: queryParams })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const getLeaveApplicationsPendingCount = baseUrl => {
  const path = `${baseUrl}/leave_applications/pending_count`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data.json, status }))
    .catch(error => ({ error }));
};

export const getLeaveApplicationsApprovedCount = baseUrl => {
  const path = `${baseUrl}/leave_applications/approved_count`;
  return customAxios.get(path)
    .then(({ data, status }) => ({ response: data.json, status }))
    .catch(error => ({ error }));
};

export async function openLeaveApplicationsDashboardPdf(baseUrl, queryParams = {}) {
  const path = `${baseUrl}/leave_applications/dashboard_pdf`;
  const qs = new URLSearchParams();
  ["period_from", "period_to", "user_id", "status_filter"].forEach(key => {
    const v = queryParams[key];
    if (v !== undefined && v !== null && v !== "") qs.append(key, String(v));
  });

  const token = typeof gon !== "undefined" && gon.auth_token ? gon.auth_token : "";
  const csrfMeta = typeof document !== "undefined" ? document.querySelector('meta[name="csrf-token"]') : null;
  const csrf = csrfMeta?.getAttribute("content");

  return fetchAndOpenPdf(`${path}?${qs.toString()}`, {
    headers: {
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...(token ? { Authorization: token } : {}),
      Accept: "application/pdf",
    },
    defaultFilename: "leave-applications.pdf",
  });
}

export const approveLeaveApplication = (baseUrl, id) => {
  const path = `${baseUrl}/leave_applications/${id}/approve`;
  return customAxios.post(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const declineLeaveApplication = (baseUrl, id, reason) => {
  const path = `${baseUrl}/leave_applications/${id}/decline`;
  return customAxios.post(path, { reason })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const updateLeaveApplicationCoverage = (baseUrl, id, coverageDetails) => {
  const path = `${baseUrl}/leave_applications/${id}/update_coverage`;
  return customAxios.post(path, { coverage_details: coverageDetails })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};
